import * as yup from 'yup'

/** The backend accepts '' but a discard with no reason is unauditable — required here. */
export const discardEventValidator = yup.object({
  notes: yup.string().test('not-blank', 'Say why this event is being discarded', (value) => {
    return (value ?? '').trim().length > 0
  }),
})
